import { render, staticRenderFns } from "./Insight_Play.vue?vue&type=template&id=61082e12&scoped=true"
import script from "./Insight_Play.vue?vue&type=script&lang=js"
export * from "./Insight_Play.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61082e12",
  null
  
)

export default component.exports